/**
 * External dependencies
 */
import { get } from 'lodash';

export const getOperationId = state => get(state, 'ui.operationDetailsModal.operationId', null);